/**
 * ============================================================
 * S6: custom-inquiry-widget.js
 * 100Totes — Freshdesk Widget 询盘联动 v3
 *
 * 移植自 WholesaleTumblers（母版: shopify项目/wholesaletumblers/assets/custom-inquiry-widget.js）
 *   - widget_id 换为 100Totes 专属 156000001529（绝不可用 WT 的 156000001455）
 *   - Subject 品牌字样换为 "100Totes.com"
 *   - 触发按钮 ID 换为 #totes-inquiry-open（对应 custom-inquiry-form.liquid）
 *   - 产品上下文改为通过 Custom Fields 传递（客户不可见）:
 *       cf_product_url     → 自动填入当前产品页 URL
 *       cf_product_color   → 自动填入当前选中颜色
 *       cf_product_imprint → 自动填入当前选中印刷方式
 *   - 隐藏 name / subject 字段
 *   - 右下角浮动 Launcher 保持隐藏
 * 移植: 2026-07-23
 * ============================================================
 */
(function () {
  'use strict';

  /* ── 等待 Freshdesk Widget 脚本就绪 ── */
  function waitForWidget(cb) {
    if (typeof window.FreshworksWidget === 'function') {
      cb();
    } else {
      var t = setInterval(function () {
        if (typeof window.FreshworksWidget === 'function') {
          clearInterval(t);
          cb();
        }
      }, 200);
    }
  }

  /* ── 读取当前页面上下文 ── */
  function getProductContext() {
    var ctx = {
      title: '',
      url: window.location.origin + window.location.pathname,
      color: '',
      imprint: ''
    };

    // 产品标题
    var titleEl = document.querySelector(
      'h1.product__title, .product__title h1, h1[class*="title"]'
    );
    if (titleEl) ctx.title = titleEl.textContent.trim();

    // 优先方法: 用 __WT_PRICE_TIERS 读取当前变体的所有选项（若100Totes也复用同名全局变量）
    var DATA = window.__WT_PRICE_TIERS;
    if (DATA && DATA.variants && DATA.imprintOptionIndex >= 0) {
      // 读取当前变体 ID
      var params = new URLSearchParams(window.location.search);
      var currentId = parseInt(params.get('variant'), 10);
      if (!currentId) {
        var hiddenId = document.querySelector('input[name="id"]');
        currentId = hiddenId ? parseInt(hiddenId.value, 10) : (DATA.currentVariantId || 0);
      }

      for (var i = 0; i < DATA.variants.length; i++) {
        if (DATA.variants[i].id === currentId) {
          var opts = DATA.variants[i].options;
          var impIdx = DATA.imprintOptionIndex;
          ctx.imprint = opts[impIdx] || '';
          // Color = 第一个不是 Imprint 的 option
          for (var j = 0; j < opts.length; j++) {
            if (j !== impIdx) { ctx.color = opts[j] || ''; break; }
          }
          break;
        }
      }
    }

    // 小常备用: DOM selector方法
    if (!ctx.imprint) {
      var impEl = document.querySelector(
        'input[name="Imprint"]:checked, input[name="imprint"]:checked'
      );
      if (impEl) ctx.imprint = impEl.value;
    }
    if (!ctx.color) {
      var colorEl = document.querySelector(
        'input[name="Color"]:checked, input[name="color"]:checked'
      );
      if (colorEl) ctx.color = colorEl.value;
    }

    console.log('[Totes Inquiry] ctx:', JSON.stringify(ctx));
    return ctx;
  }

  /* ── 配置并打开 Widget ── */
  function openInquiryWidget() {
    var ctx = getProductContext();

    var subject = ctx.title
      ? 'Inquiry for ' + ctx.title + ' - 100Totes.com'
      : 'Inquiry - 100Totes.com';

    // 不调用 clear（clear 会清除 prefill 内容，导致 subject 为空）
    FreshworksWidget('prefill', 'ticketForm', {
      subject: subject,
      custom_fields: {
        cf_product_url:     ctx.url,
        cf_product_color:   ctx.color,
        cf_product_imprint: ctx.imprint
      }
    });

    // 客户隐藏 subject + 三个 custom fields，工单后台均可见
    FreshworksWidget('hide', 'ticketForm', [
      'subject',
      'custom_fields.cf_product_url',
      'custom_fields.cf_product_color',
      'custom_fields.cf_product_imprint'
    ]);

    FreshworksWidget('open', 'ticketForm');
  }

  /* ── 初始化 ── */
  waitForWidget(function () {
    // 隐藏右下角浮动 Launcher，仅通过我们的按钮触发
    FreshworksWidget('hide', 'launcher');

    function bindButtons() {
      var bound = false;

      // 方法 1: 精确 ID 绑定（来自 custom-inquiry-form.liquid 的按钮）
      var btn = document.getElementById('totes-inquiry-open');
      if (btn && !btn.dataset.fdBound) {
        btn.dataset.fdBound = '1';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation(); // 防止旧逻辑干扰
          openInquiryWidget();
        }, true); // 捕获阶段，优先执行
        bound = true;
      }

      // 方法 2: 文字匹配兜底（防止 ID 变化）
      if (!bound) {
        var allBtns = document.querySelectorAll('button, a');
        for (var i = 0; i < allBtns.length; i++) {
          var txt = allBtns[i].textContent.trim().toLowerCase();
          if (
            (txt.indexOf('inquiry') > -1 || txt.indexOf('make inquiry') > -1) &&
            !allBtns[i].dataset.fdBound
          ) {
            allBtns[i].dataset.fdBound = '1';
            allBtns[i].addEventListener('click', function (e) {
              e.preventDefault();
              e.stopImmediatePropagation();
              openInquiryWidget();
            }, true);
          }
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        bindButtons();
        updateHintText();
      });
    } else {
      bindButtons();
      updateHintText();
    }

    /* ── 动态更新按钮提示文字（根据产品实际选项名） ── */
    function updateHintText() {
      var subEl = document.querySelector('.totes-inquiry-btn__sub');
      if (!subEl) return;

      // 从 fieldset legend 读取产品变体选项名（精确匹配，不含 Quantity 等非选项标签）
      var optionNames = [];
      var legends = document.querySelectorAll('fieldset.product-form__input legend');
      for (var i = 0; i < legends.length; i++) {
        var raw = legends[i].childNodes[0];
        var name = raw ? raw.textContent.trim().replace(/:.*$/, '').trim() : '';
        // 过滤掉 Quantity 等非变体选项
        var skip = ['quantity', 'qty', '数量'];
        if (name && skip.indexOf(name.toLowerCase()) === -1 && optionNames.indexOf(name) === -1) {
          optionNames.push(name);
        }
      }

      if (optionNames.length > 0) {
        subEl.textContent = 'Select ' + optionNames.join(' & ') + ' before submitting';
      }
      // 如果读不到，保留默认文字（liquid 里已有兜底）
    }
  });

})();
